import {PaymentMethodDao} from '../../dao';
import {ErrorModel, PaymentMethodModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_PAYMENT_METHODS';

export async function getAllPaymentMethods(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const paymentMethods = await PaymentMethodDao.getAllPaymentMethods(userData?.userToken as string, params, page);

        const paymentMethodParsed = paymentMethods.results.map((paymentMethod: Record<string, any>) => PaymentMethodModel.parsePaymentMethod(paymentMethod));

        return paymentMethodParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
